import BaseComponent from "@js/components/base_component.jsx";

import MuiUserRolesForm from "@js/components/mui/user_roles/form.jsx";

class MuiUserRolesShow extends BaseComponent {
  render() {
    return <MuiUserRolesForm { ...this.props } editing={ false } />;
  }
}

export default MuiUserRolesShow;
